import React from "react";
import { OrderGroupDetails } from "./details/OrderGroupDetails";
import { OrderGroupIndex } from "./index/OrderGroupIndex";
import { BUY_FOR_ME_GROUPS } from "./orderGroupKinds";

/** List of Buy For Me order groups. */
export const BuyForMeGroupIndex: React.FC = () => <OrderGroupIndex kind={BUY_FOR_ME_GROUPS} />;

/** Page of one Buy For Me order group. */
export const BuyForMeGroupDetails: React.FC = () => <OrderGroupDetails kind={BUY_FOR_ME_GROUPS} />;
